<ct-model *ngIf="configuration" [configuration]="configuration"></ct-model>

<ng-template #legendTemplate>
  <!-- ✅ RIMOSSO: Bottone export custom -->
  <!-- Il bottone export viene ora gestito automaticamente nella toolbar -->
  <!-- tramite CtExportConfiguration nella configuration -->
  
  <!-- Se in futuro servono altri bottoni custom nella legend, aggiungerli qui -->
</ng-template>
